import { BaseAction } from "./BaseAction";
export class BannerAction extends BaseAction {
    execute() {
        this.renderTemplate();
        return true;
    }
}
